// extracted by mini-css-extract-plugin
module.exports = {"statsContainer":"style_statsContainer__2wPhZ","lineChartDiv":"style_lineChartDiv__3Ru1X"};